import React, { useState, useEffect } from "react";
import { Backdrop, CircularProgress, Button, Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { FilterMatchMode } from "primereact/api";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import "./table.css";
import { useLocation } from "react-router-dom";
import dayjs from "dayjs";
import Swal from "sweetalert2";

const SCFSurveyForm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [token, setToken] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [isInitializingSurvey, setIsInitializingSurvey] = useState(true);
  const [alreadySubmitted, setAlreadySubmitted] = useState(false);
  const [alreadySubmittedCountdown, setAlreadySubmittedCountdown] = useState(6);

  useEffect(() => {
    if (!alreadySubmitted) return;
    const interval = setInterval(() => {
      setAlreadySubmittedCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          window.location.href = "https://ecoprism.com/";
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [alreadySubmitted]);
  const [data, setData] = useState([
    {
      productOrService: "",
      productOrServiceName: "",
      productCategory: "",
      quantity: "",
      unit: "",
      value: "",
      currency: "",
      isAdded: false,
    },
  ]);
  const [getCurrency, setGetCurrency] = useState([]);
  const [currency, setCurrency] = useState("");

  const [surveyFromDate, setSurveyFromDate] = useState("");
  const [surveyToDate, setSurveyToDate] = useState("");
  const [validFromDate, setValidFromDate] = useState("");
  const [validToDate, setValidToDate] = useState("");
  const [surveyToken, setSurveyToken] = useState("");
  const [supplierName, setSupplierName] = useState("");
  const [companyId, setCompanyId] = useState("");
  const [countries, setCountries] = useState();
  const [formData, setFormData] = useState({
    country: "",
  });

  const [errors, setErrors] = useState({});
  const [rowErrors, setRowErrors] = useState([{}]);

  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    productOrService: { value: null, matchMode: FilterMatchMode.CONTAINS },
    productOrServiceName: { value: null, matchMode: FilterMatchMode.CONTAINS },
    productCategory: { value: null, matchMode: FilterMatchMode.CONTAINS },
    quantity: { value: null, matchMode: FilterMatchMode.CONTAINS },
    unit: { value: null, matchMode: FilterMatchMode.CONTAINS },
    value: { value: null, matchMode: FilterMatchMode.CONTAINS },
    currency: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const handleExpiredSurvey = () => {
    // Your custom logic here
    console.log("Handling expired survey");
    // If you still need to navigate eventually, you can do it here
    navigate("/");
  };
  useEffect(() => {
    async function fetchCurrency() {
      try {
        const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}currencies`, {
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            username: localStorage.getItem("userName"),
          },
        });
        const data = await response.json();
        setGetCurrency(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error("Error fetching currency data:", error);
      }
    }

    fetchCurrency(); // Call the fetch function
  }, []);

  async function fetchCountries() {
    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}countries`);
      const data = await response.json();
      setCountries(data);
    } catch (error) {
      console.error(error);
    }
  }

  const hasSurveyBeenSubmitted = async (
    tokenValue,
    companyid,
    supplierNameValue,
    surveyFromDateValue,
    surveyToDateValue
  ) => {
    const surveyStatusEndpoint =
      process.env.REACT_APP_SCF_SURVEY_STATUS_API_URL ||
      `${process.env.REACT_APP_BASE_API_URL}check-supplier-carbon-footprint-survey-link-status`;

    try {
      const response = await fetch(surveyStatusEndpoint, {
        method: "POST",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
        body: JSON.stringify({
          token: tokenValue,
          companyId: companyid,
          supplierName: supplierNameValue,
          surveyFromDate: surveyFromDateValue,
          surveyToDate: surveyToDateValue,
        }),
      });

      if (!response.ok) {
        return false;
      }

      const responseText = await response.text();
      let responseJson;
      try {
        responseJson = JSON.parse(responseText);
      } catch (parseError) {
        responseJson = responseText;
      }

      const normalizedResponseText = (responseText || "").toString().toLowerCase();
      const normalizedResponseJsonText =
        typeof responseJson === "string"
          ? responseJson.toLowerCase()
          : JSON.stringify(responseJson || {}).toLowerCase();

      const hasDuplicateOrSubmittedMessage =
        normalizedResponseText.includes("duplicate survey") ||
        normalizedResponseText.includes("already submitted") ||
        normalizedResponseText.includes("already filled") ||
        normalizedResponseJsonText.includes("duplicate survey") ||
        normalizedResponseJsonText.includes("already submitted") ||
        normalizedResponseJsonText.includes("already filled");

      return (
        responseJson === true ||
        responseJson === "true" ||
        responseJson?.alreadyFilled === true ||
        responseJson?.isSubmitted === true ||
        responseJson?.submitted === true ||
        responseJson?.data === true ||
        responseJson?.data === "true" ||
        responseJson?.data?.isSurveyFilled === true ||
        responseJson?.data?.IsSurveyFilled === true ||
        responseJson?.data?.alreadyFilled === true ||
        responseJson?.data?.isSubmitted === true ||
        responseJson?.data?.submitted === true ||
        responseJson?.data?.ReasonCode === "AlreadySubmitted" ||
        hasDuplicateOrSubmittedMessage
      );
    } catch (error) {
      console.error("Error checking survey submission status:", error);
      return false;
    }
  };

  useEffect(() => {
    const initializeSurvey = async () => {
      let hasRedirected = false;
      const queryParams = new URLSearchParams(location.search);
      const tokenFromUrl = queryParams.get("token");
      const empEmail = queryParams.get("email");
      setEmail(empEmail);
      if (tokenFromUrl) {
        if (localStorage.getItem(`scf_survey_submitted_${tokenFromUrl}`) === "true") {
          hasRedirected = true;
          setAlreadySubmitted(true);
          setIsInitializingSurvey(false);
          return;
        }

        console.log(tokenFromUrl);
        const decodedString = atob(tokenFromUrl);
        const [companyid, formattedFromDate, formattedToDate, formattedExpiryDate, formattedDate, supplierName] = decodedString.split(":");
        console.log("Decoded String:", decodedString);

        const fromParts = formattedFromDate.split("-");
        const fromDate = `${fromParts[2]}-${fromParts[1]}-${fromParts[0]}`;

        const toParts = formattedToDate.split("-");
        const toDate = `${toParts[2]}-${toParts[1]}-${toParts[0]}`;

        const fromPartsEx = formattedExpiryDate.split("-");
        const fromDateEx = `${fromPartsEx[2]}-${fromPartsEx[1]}-${fromPartsEx[0]}`;
        console.log(fromDateEx); // 30-04-2025

        // Get current date in DD-MM-YYYY format
        const currentDate = dayjs().format("YYYY-MM-DD");

        // Debug logs
        console.log("Current Date:", currentDate);
        console.log("Expiry Date:", fromDateEx);

        // Convert both dates to dayjs objects with explicit DD-MM-YYYY format
        const currentDateObj = dayjs(currentDate);
        const expiryDateObj = dayjs(fromDateEx);

        // Debug logs for parsed dates
        console.log("Current Date Object:", currentDateObj.format());
        console.log("Expiry Date Object:", expiryDateObj.format());

        // Compare dates using isValid() check and isAfter()
        if (currentDateObj.isValid() && expiryDateObj.isValid()) {
          if (currentDateObj.isAfter(expiryDateObj)) {
            Swal.fire({
                          width: 400,
                          heightAuto: false,
              icon: "error",
              html: `<h4 style="color: #CC2229; font-size: 20px; font-weight: bold;">Error!</h4>
                     <p style="font-size: 16px;">This survey has expired. Please reach out to the system administrator for assistance.</p>`,
              iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
              confirmButtonText: "OK",
              confirmButtonColor: "#CC2229",
              allowOutsideClick: false,
              allowEscapeKey: false,
            }).then((result) => {
              if (result.isConfirmed) {
                handleExpiredSurvey();
              }
            });
            return;
          }
        } else {
          console.error("Invalid date format detected");
          console.error("Current Date:", currentDate);
          console.error("Expiry Date:", fromDateEx);
        }

        const isAlreadySubmitted = await hasSurveyBeenSubmitted(
          tokenFromUrl,
          companyid,
          supplierName,
          formattedFromDate,
          formattedToDate
        );
        if (isAlreadySubmitted) {
          hasRedirected = true;
          setAlreadySubmitted(true);
          setIsInitializingSurvey(false);
          return;
        }

        setFormData({
          ...formData,
          surveyPeriod: fromDate + " to " + toDate,
          employeeEmail: empEmail, // Set the state based on the selected location
        });
        setSurveyFromDate(formattedFromDate);
        setSurveyToDate(formattedToDate);
        setValidFromDate(formattedFromDate);
        setValidToDate(formattedToDate);
        setSurveyToken(tokenFromUrl);
        setSupplierName(supplierName);
        setCompanyId(companyid);
        setToken(tokenFromUrl);
      }
      console.log(formData);
      fetchCountries();
      
      // Load data from localStorage only if user has previously saved it by clicking Next
      const storedScfStep1 = localStorage.getItem("scfStep1");
      const formInProgress = localStorage.getItem("scfFormInProgress");
      
      if (storedScfStep1 && formInProgress === "true") {
        // User has previously filled the form and clicked Next, so restore the data
        try {
          const parsedScfStep1 = JSON.parse(storedScfStep1);
          // Only load data if the stored token matches the current token
          if (parsedScfStep1.token && parsedScfStep1.token === tokenFromUrl) {
            if (parsedScfStep1.country) {
              setFormData((prevData) => ({
                ...prevData,
                country: parsedScfStep1.country,
              }));
            }
            if (parsedScfStep1.rowData && Array.isArray(parsedScfStep1.rowData)) {
              setData(parsedScfStep1.rowData);
            }
            if (parsedScfStep1.email) {
              setEmail(parsedScfStep1.email);
            }
          }
        } catch (error) {
          console.error("Error loading saved form data:", error);
        }
      } else {
        // First time landing or no saved progress - ensure clean state
        localStorage.removeItem("scfStep1");
        localStorage.removeItem("scfFormInProgress");
      }

      if (!hasRedirected) {
        setIsInitializingSurvey(false);
      }
    };

    initializeSurvey();
  }, []);
  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    setFilters((prevFilters) => ({
      ...prevFilters,
      global: { value: value, matchMode: FilterMatchMode.CONTAINS },
    }));
    setGlobalFilterValue(value);
  };

  const cities = [
    { label: "country 1", value: "country 1" },
    { label: "country 2", value: "country 2" },
    { label: "country 3", value: "country 3" },
  ];

  const validateForm = () => {
    const newErrors = {};
    if (!formData.country) newErrors.country = "Country is required";

    const newRowErrors = data.map((row) => {
      const rowError = {};
      if (!row.productOrService) rowError.productOrService = true;
      if (!row.productCategory) rowError.productCategory = true;
      if (row.productOrService === "Product") {
        if (row.quantity === null || row.quantity === "" || row.quantity === undefined) rowError.quantity = true;
        if (!row.unit) rowError.unit = true;
        if (row.value === null || row.value === "" || row.value === undefined) rowError.value = true;
        if (!row.currency) rowError.currency = true;
      } else if (row.productOrService === "Service") {
        if (row.value === null || row.value === "" || row.value === undefined) rowError.value = true;
        if (!row.currency) rowError.currency = true;
      }
      return rowError;
    });

    setRowErrors(newRowErrors);
    if (newRowErrors.some((re) => Object.keys(re).length > 0)) {
      newErrors.tableRows = true;
    }

    setErrors(newErrors);
    return newErrors;
  };

  const handleSave = async () => {
    const newErrors = validateForm();
    if (Object.keys(newErrors).length > 0) {
      return;
    }
    setLoading(true);

    const scfStep1 = {
      country: formData.country,
      supplier: supplierName,
      rowData: data,
      token: token,
      email: email,
    };
    localStorage.setItem("scfStep1", JSON.stringify(scfStep1));
    // Set flag to indicate user has progressed to next step
    localStorage.setItem("scfFormInProgress", "true");
    setLoading(false);

    navigate("/energy-emissions");
  };

  const renderHeader = () => {
    return (
      <div className="flex justify-content-end">
        <span className="p-input-icon-left">
          <img src="assets/img/search.png" className="search-i" alt="search" />
          <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Search" />
        </span>
      </div>
    );
  };

  const header = renderHeader();

  const productOrServiceOptions = [
    { label: "Product", value: "Product" },
    { label: "Service", value: "Service" },
  ];

  const currencyOptions = [
    { label: "USD", value: "USD" },
    { label: "EUR", value: "EUR" },
    { label: "INR", value: "INR" },
  ];

  const clearRowFieldError = (rowIndex, field) => {
    setRowErrors((prev) => {
      const updated = [...prev];
      if (updated[rowIndex]) {
        const copy = { ...updated[rowIndex] };
        delete copy[field];
        updated[rowIndex] = copy;
      }
      return updated;
    });
  };

  const onProductOrServiceChange = (e, rowIndex) => {
    const updatedData = [...data];
    updatedData[rowIndex].productOrService = e.value;
    setData(updatedData);
    setRowErrors((prev) => {
      const updated = [...prev];
      updated[rowIndex] = {};
      return updated;
    });
  };

  const onCurrencyChange = (e, rowIndex) => {
    const updatedData = [...data];
    updatedData[rowIndex].currency = e.value;
    setData(updatedData);
    clearRowFieldError(rowIndex, "currency");
  };

  const textInputBodyTemplate = (rowData, field, { rowIndex }) => {
    const hasError = !!rowErrors[rowIndex]?.[field];
    if (field === "quantity" || field === "value") {
      return (
        <InputNumber
          value={rowData[field]}
          onValueChange={(e) => {
            const updatedData = [...data];
            updatedData[rowIndex][field] = e.value;
            setData(updatedData);
            clearRowFieldError(rowIndex, field);
          }}
          placeholder={`Enter ${field.charAt(0).toUpperCase() + field.slice(1)}`}
          mode="decimal"
          useGrouping={false}
          className={hasError ? "p-invalid" : ""}
        />
      );
    }

    let placeholderText = "";
    switch (field) {
      case "productOrServiceName":
        placeholderText = "Enter Product/Service Name";
        break;
      case "productCategory":
        placeholderText = "Enter Product Category";
        break;
      case "unit":
        placeholderText = "Enter Unit";
        break;
      default:
        placeholderText = "";
    }

    return (
      <InputText
        value={rowData[field]}
        onChange={(e) => {
          const updatedData = [...data];
          updatedData[rowIndex][field] = e.target.value;
          setData(updatedData);
          clearRowFieldError(rowIndex, field);
        }}
        placeholder={placeholderText}
        className={hasError ? "p-invalid" : ""}
      />
    );
  };
  const productOrServiceBodyTemplate = (rowData, { rowIndex }) => {
    const hasError = !!rowErrors[rowIndex]?.productOrService;
    return (
      <Dropdown
        value={rowData.productOrService}
        options={productOrServiceOptions}
        onChange={(e) => onProductOrServiceChange(e, rowIndex)}
        placeholder="Select"
        style={{ width: "130px" }}
        className={hasError ? "p-invalid" : ""}
      />
    );
  };

  const currencyBodyTemplate = (rowData, { rowIndex }) => {
    const hasError = !!rowErrors[rowIndex]?.currency;
    return (
      <Dropdown
        value={rowData.currency}
        onChange={(e) => onCurrencyChange(e, rowIndex)}
        options={Array.isArray(getCurrency) ? getCurrency : []}
        placeholder="Select"
        filter
        filterPlaceholder="Search currency"
        style={{ width: "150px" }}
        className={hasError ? "p-invalid" : ""}
      />
    );
  };

  const addRow = () => {
    const newRow = {
      productOrService: "",
      productOrServiceName: "",
      productCategory: "",
      quantity: "",
      unit: "",
      value: "",
      currency: "",
      isAdded: true,
    };
    setData((prevData) => [...prevData, newRow]);
    setRowErrors((prevErrors) => [...prevErrors, {}]);
  };

  const deleteRow = (rowIndex) => {
    const updatedData = [...data];
    updatedData.splice(rowIndex, 1);
    setData(updatedData);
    setRowErrors((prev) => {
      const updated = [...prev];
      updated.splice(rowIndex, 1);
      return updated;
    });
  };

  const deleteIconTemplate = (rowData, { rowIndex }) => {
    return (
      <Tooltip title="Delete" arrow>
        <img src="./assets/img/reports/delete.png" alt="Delete Icon" className="delete-icon actions-icon" onClick={() => deleteRow(rowIndex)} />
      </Tooltip>
    );
  };

  if (alreadySubmitted) {
    return (
      <div id="wrapper">
        <header>
          <nav className="navbar navbar-expand-lg navbar-light" style={{ background: "#407775" }}>
            <div className="container-fluid">
              <a className="navbar-brand" href="#home">
                <img src="assets/img/logo.png" alt="Company Logo" height="30" className="d-inline-block align-top" />
              </a>
            </div>
          </nav>
        </header>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "calc(100vh - 56px)",
            background: "#fff",
          }}
        >
          <div
            style={{
              textAlign: "center",
              padding: "48px 40px",
              maxWidth: "480px",
              width: "100%",
              background: "#fff",
              borderRadius: "12px",
              border: "1px solid #f0e8e8",
              boxShadow: "0 2px 20px rgba(0,0,0,0.06)",
            }}
          >
            <div
              style={{
                width: 72,
                height: 72,
                borderRadius: "50%",
                background: "#fde8e8",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 16px",
              }}
            >
              <svg
                width="32"
                height="32"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#407775"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                <polyline points="9 12 11 14 15 10" />
              </svg>
            </div>
            <span
              style={{
                display: "inline-block",
                background: "#fde8e8",
                color: "#c0392b",
                padding: "4px 16px",
                borderRadius: "20px",
                fontSize: "13px",
                fontWeight: 500,
                marginBottom: "16px",
              }}
            >
              Survey already submitted
            </span>
            <h2
              style={{
                color: "#c0392b",
                fontWeight: 700,
                fontSize: "22px",
                marginBottom: "12px",
              }}
            >
              Thank You for Your Response!
            </h2>
            <p
              style={{
                color: "#888",
                fontSize: "15px",
                lineHeight: "1.6",
                marginBottom: "20px",
              }}
            >
              It seems this survey has already been completed. We truly appreciate
              the time and effort you put into sharing your insights — your
              contribution means a lot to us.
            </p>
            <div
              style={{
                background: "#fde8e8",
                padding: "14px 16px",
                borderRadius: "8px",
                marginBottom: "28px",
                textAlign: "left",
              }}
            >
              <p style={{ color: "#c0392b", margin: 0, fontSize: "14px", lineHeight: "1.5" }}>
                If you think this is a mistake, please contact the person or team
                who shared the survey link with you.
              </p>
            </div>
            <p style={{ fontSize: "14px", color: "#888", marginTop: "16px" }}>
              Redirecting to{" "}
              <a href="https://ecoprism.com/" style={{ color: "#407775" }}>ecoprism.com</a>{" "}
              in {alreadySubmittedCountdown} second{alreadySubmittedCountdown !== 1 ? "s" : ""}...
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div id="wrapper">
      {loading && (
        <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={true}>
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <div id="">
        <header>
          <nav className="navbar navbar-expand-lg navbar-light" style={{ background: "#407775" }}>
            <div className="container-fluid">
              <a className="navbar-brand" href="#home">
                <img src="assets/img/logo.png" alt="Company Logo" height="30" className="d-inline-block align-top" />
              </a>
              <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
              </button>
              <div className="collapse navbar-collapse justify-content-end" id="navbarSupportedContent">
                <ul className="navbar-nav mb-2 mb-lg-0">
                  <li className="nav-item">
                    <a className="nav-link text-white" href="#profile">
                      <img class="icon mr-3" src="assets/img/User.png" alt="User" />
                      {supplierName || "Supplier"}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
        </header>
        {isInitializingSurvey ? (
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "calc(100vh - 60px)", gap: "16px" }}>
            <CircularProgress style={{ color: "#407775" }} />
            <p style={{ fontSize: "16px", color: "#407775", fontWeight: 500, margin: 0 }}>Validating Survey Link...</p>
          </div>
        ) : (
        <div className="container survey-form scf p-4 p-lg-5">
          <div className="row mb-4">
            <div className="col">
              <div className="form-header">
                <h1 className="title" style={{ color: "407775!important" }}>
                  Supplier Carbon Footprint​ Survey
                </h1>
              </div>
            </div>
          </div>
          <div className="form-part">
            <form>
              <div className="row gx-5 gy-3">
                <div className="col-md-5">
                  <div className="form-group">
                    <label className="formlable" htmlFor="supplierName">
                      Supplier Name
                    </label>
                    <input type="text" id="supplierName" value={supplierName} class="form-control" placeholder="Auto-populated" disabled />
                  </div>
                </div>
              </div>
              <div className="row gx-5 gy-3">
                <div className="col-md-5">
                  <div className="form-group">
                    <label className="formlable" htmlFor="supplierLocation">
                      Supplier Location <span className="mark-form">*</span>
                    </label>
                    <Dropdown 
                      id="country" 
                      name="country" 
                      className={`form-control wd-100 ${errors.country ? "is-invalid" : ""}`} 
                      value={formData.country} 
                      options={countries} 
                      onChange={(e) => { setFormData({ ...formData, country: e.value }); setErrors((prev) => { const { country: _, ...rest } = prev; return rest; }); }}
                      placeholder="Select country" 
                      filter 
                      filterPlaceholder="Search country"
                      required 
                    />
                    {errors.country && <div className="invalid-feedback">{errors.country}</div>}
                  </div>
                </div>
              </div>
              <div className="row gx-5 gy-3">
                <div className="col-md-5">
                  <div className="form-group">
                    <label className="formlable" htmlFor="surveyPeriod">
                      Survey Period
                    </label>
                    <input type="text" id="surveyPeriod" value={formData.surveyPeriod} class="form-control" placeholder="Auto-populated" disabled />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="survey-content">
                  <div className="data-responsive">
                    <DataTable
                      value={data}
                      paginator
                      rows={10}
                      rowsPerPageOptions={[10, 20, 25, 50]}
                      tableStyle={{ minWidth: "50rem" }}
                      paginatorTemplate={`
    AddRowButton
    RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink
  `}
                      currentPageReportTemplate="{first} to {last} of {totalRecords}"
                      filters={filters}
                      filterDisplay="row"
                      globalFilterFields={["productOrService", "productOrServiceName", "productCategory", "quantity", "unit", "value", "currency"]}
                      header={header}
                      emptyMessage="No data found."
                      paginatorRight={
                        <div className="d-flex justify-content- mb-3">
                          <span onClick={addRow} className="add-row-button">
                            + Add Row
                          </span>
                        </div>
                      }
                    >
                      <Column
                        header=""
                        body={deleteIconTemplate}
                        style={{
                          width: "3rem",
                          textAlign: "center",
                          padding: "0 20px",
                        }}
                      />
                      <Column field="productOrService" header="Product/Service" sortable filter filterPlaceholder="Filter" body={productOrServiceBodyTemplate} style={{ width: "150px" }} />
                      <Column header="Product/Service Name" field="productOrServiceName" sortable filter filterPlaceholder="Filter" body={(rowData, props) => textInputBodyTemplate(rowData, "productOrServiceName", props)} style={{ width: "150px" }} />
                      <Column header="Product Category" field="productCategory" sortable filter filterPlaceholder="Filter" body={(rowData, props) => textInputBodyTemplate(rowData, "productCategory", props)} style={{ width: "150px" }} />
                      <Column header="Quantity" field="quantity" sortable filter filterPlaceholder="Filter" body={(rowData, props) => textInputBodyTemplate(rowData, "quantity", props)} style={{ width: "150px" }} />
                      <Column header="Unit" field="unit" sortable filter filterPlaceholder="Filter" body={(rowData, props) => textInputBodyTemplate(rowData, "unit", props)} style={{ width: "150px" }} />
                      <Column header="Value" field="value" sortable filter filterPlaceholder="Filter" body={(rowData, props) => textInputBodyTemplate(rowData, "value", props)} style={{ width: "150px" }} />
                      <Column header="Currency" field="currency" sortable filter filterPlaceholder="Filter" body={currencyBodyTemplate} style={{ width: "150px" }} />
                    </DataTable>
                    {errors.tableRows && <div className="invalid-feedback" style={{ display: "block" }}>Please fill all required fields highlighted in red.</div>}
                  </div>
                </div>
              </div>
            </form>
            <div className="forms-buttons-container">
              {/* <Button
                className="outline-btn"
                variant="contained"
                color="primary"
                startIcon={
                  <ArrowBackIosIcon sx={{ fontSize: "12px!important", marginRight: "0" }} />
                }
                onClick={() => navigate("/previous-page")}
                disabled
              >
                Back
              </Button> */}
              <Button className="next-button" variant="contained" color="primary" endIcon={<ArrowForwardIosIcon sx={{ fontSize: "12px!important", marginLeft: "0" }} />} onClick={handleSave}>
                Next
              </Button>
            </div>
          </div>
        </div>
        )}
      </div>
    </div>
  );
};

export default SCFSurveyForm;
